import React from 'react';
import { Path } from 'react-hook-form';
import { ISimulationPayload } from '@schemas/scenarios-simulator/types';

import HistorySection from './history-section';
import { ScenarioBasePath } from '@hooks/scenarios-simulator/types';

interface IHistorySectionProps {
  fieldName: string;
  unitNum: number;
  scenarioBasePath: ScenarioBasePath;
}

export enum HistoryKeys {
  ConsumptionHistory = 'ConsumptionHistory',
  DemandHistory = 'DemandHistory',
  PeakConsumptionHistory = 'PeakConsumptionHistory',
  OffPeakConsumptionHistory = 'OffPeakConsumptionHistory',
  PeakDemandHistory = 'PeakDemandHistory',
  OffPeakDemandHistory = 'OffPeakDemandHistory',
}
interface HistorySectionConfig {
  sectionTitle: string;
  title: string;
  subtitle: string;
  tooltipContent: string;
  key: HistoryKeys;
}

const createHistorySection = (config: HistorySectionConfig) => {
  const Component = React.memo(({ fieldName, unitNum, scenarioBasePath }: IHistorySectionProps) => (
    <HistorySection<ISimulationPayload>
      sectionTitle={config.sectionTitle}
      title={config.title}
      subtitle={config.subtitle}
      tooltipContent={config.tooltipContent}
      activeClipboard={true}
      field={fieldName as Path<ISimulationPayload>}
      scenarioBasePath={scenarioBasePath}
      unitNum={unitNum}
      historyKey={config.key}
    />
  ));
  Component.displayName = `HistorySection${config.title.replace(/\s+/g, '')}`;
  return Component;
};

export const MountHistorySection = {
  Consumption: createHistorySection({
    sectionTitle: 'Histórico de consumo',

    title: 'Editar projeções de consumo',
    subtitle: '',
    tooltipContent: 'Informe o histórico de consumo dos últimos 12 meses',
    key: HistoryKeys.ConsumptionHistory,
  }),
  Demand: createHistorySection({
    sectionTitle: 'Histórico de demanda',

    title: 'Editar projeções de consumo',
    subtitle: '',
    tooltipContent: 'Informe o histórico de demanda dos últimos 12 meses',
    key: HistoryKeys.DemandHistory,
  }),
  PeakConsumption: createHistorySection({
    sectionTitle: 'Histórico de consumo ponta',

    title: 'Editar projeções de consumo',
    subtitle: '',
    tooltipContent: 'Informe o histórico de consumo ponta dos últimos 12 meses',
    key: HistoryKeys.PeakConsumptionHistory,
  }),
  OffPeakConsumption: createHistorySection({
    sectionTitle: 'Histórico de consumo fora de ponta',
    title: 'Editar projeções de consumo',
    subtitle: '',
    tooltipContent: 'Informe o histórico de consumo fora de ponta dos últimos 12 meses',
    key: HistoryKeys.OffPeakConsumptionHistory,
  }),
  PeakDemand: createHistorySection({
    sectionTitle: 'Histórico de demanda ponta',

    title: 'Editar projeções de consumo',
    subtitle: '',
    tooltipContent: 'Informe o histórico de demanda ponta dos últimos 12 meses',
    key: HistoryKeys.PeakDemandHistory,
  }),
  OffPeakDemand: createHistorySection({
    sectionTitle: 'Histórico de demanda fora de ponta',

    title: 'Editar projeções de consumo',
    subtitle: '',
    tooltipContent: 'Informe o histórico de demanda fora de ponta dos últimos 12 meses',
    key: HistoryKeys.OffPeakDemandHistory,
  }),
} as const;
